__turbopack_context__.v({
  "ArtistCardList__Container": "rkrZmW_ArtistCardList__Container",
  "ArtistCardList__List": "rkrZmW_ArtistCardList__List",
});
